const TX_TYPES = [
  "AGENT_CASHOUT",
  "AGENT_DEPOSIT",
  "MOMO_CASHOUT",
  "MOMO_DEPOSIT",
  "MERCHANT_PAYMENT",
  "MERCHANT_DEPOSIT",
  "P2P_TRANSFER",
  "SEND_MONEY",
  "MAKE_PAYMENT",
  "DIRECT_PAY",
  "DIRECT_TRANSFER",
  "SUB_ACCOUNT_PAYOUT",
];

export default TX_TYPES;
